<template>
<svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="12" cy="12" r="12" fill="#F9F9F9"/>
<path d="M7.90678 17.1491C7.90678 17.8824 8.52073 18.4824 9.27112 18.4824H14.7285C15.4789 18.4824 16.0928 17.8824 16.0928 17.1491V9.14909H7.90678V17.1491ZM16.775 7.14909H14.3874L13.7052 6.48242H10.2944L9.61221 7.14909H7.22461V8.48242H16.775V7.14909Z" fill="#B8CDD7"/>
</svg>


</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
svg {
    path,circle {
        transition: all 0.2s ease;
    }
    &:hover {
        path {
            fill: #ffffff;
        }
        circle {
            fill: #FA5C7C;
        }
    }
}
</style>